<template>
  <div :class="!isLandscape ? 'costContainer' : 'costContainer1'">
    <div class="headerCon">
      <div class="left"><van-icon name="arrow-left" @click="$router.replace('/insuranceHome');" /></div>
      <div class="headerTit">商保填报信息查询</div>
      <div class="right">
      </div>
    </div>
    <div class="selectCon">
      <el-input v-model="keywords" placeholder="请输入要查询的信息" prefix-icon="el-icon-search" size="medium"
        @change="changePolicyStatus" ref="select" @blur.native.capture="onblur" @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"></el-input>
      <el-select v-model="policyStatus" placeholder="请选择查询关联投保状态" size="medium" @change="changePolicyStatus" clearable>
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="costContent">
      <el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#F7F9FA' }"
        :max-height="windowHeight" v-loading="loading">
        <el-table-column prop="empno" label="工号" align="center" width="80">
        </el-table-column>
        <el-table-column prop="employeeName" label="姓名" align="center" width="80">
        </el-table-column>
        <!-- <el-table-column prop="relationType" align="center" label="关联投保关系" width="80">
        </el-table-column> -->
        <el-table-column prop="childName" align="center" label="关联投保姓名" width="80">
        </el-table-column>
        <el-table-column prop="isInsured" align="center" label="是否为子女参保" width="80">
        </el-table-column>
        <el-table-column prop="gender" align="center" label="投保子女性别" width="80">
        </el-table-column>
        <el-table-column prop="idType" align="left" label="关联投保证件类型" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="idNumber" align="center" label="关联投保证件号" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="birthDate" align="center" label="投保子女出生日期" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="isMarried" align="center" label="投保子女婚否" width="80">
        </el-table-column>
        <el-table-column prop="isStudent" align="center" label="投保子女是否在校生" width="90">
        </el-table-column>
        <el-table-column prop="schoolCity" align="center" label="投保子女学校城市" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="schoolName" align="center" label="投保子女学校名称" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="paymentType" align="center" label="付费类型" width="80">
        </el-table-column>
        <el-table-column prop="startDate" align="center" label="保单生效时间" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="endDate" align="center" label="保单失效时间" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="active" align="center" label="在职状态" width="80">
        </el-table-column>
        <el-table-column prop="policyStatus" align="center" label="关联投保信息状态" width="80">
        </el-table-column>
        <el-table-column prop="declareTime" align="center" label="最后变更日期" width="80" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="pageContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageData.page" :page-sizes="[10, 20, 50, 80, 100]" :page-size="pageData.pageSize"
          layout="total, prev, pager, next,sizes" :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="footerBtn">
      <div v-loading="exportBtnLoading" class="btn exportBtn" @click="hanleExport"><img
          src="@/assets/insurance/daochu.png" alt="">商保填报导出</div>


      <van-uploader :max-count="1" :after-read="afterTwo" class="btn importBtn"
        accept=".xlsx,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        :max-size="20480 * 1024">
        <div class=" importBtn"><img src="@/assets/insurance/daoru.png" alt="">保单信息导入</div>
      </van-uploader>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/insurance.js";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  name: "commercialFill",
  data() {
    return {
      options: [
        {
          label: '新建',
          value: '新建'
        },
        {
          label: '变更',
          value: '变更'
        },
        {
          label: '正常',
          value: '正常'
        },
        {
          label: '失效',
          value: '失效'
        },
        {
          label: '未关联',
          value: '未关联'
        },
      ],
      policyStatus: '',
      keywords: '',
      tableData: [],
      childrenNameList: [],
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      fileListTwo: [],
      windowHeight: '700',
      windowHeight1: '',
      isLandscape: false,
      style: {
        "--width": document.documentElement.clientWidth / 59.8 + "rem",
      },
      loading: false,
      exportBtnLoading: false
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    // window.addEventListener('resize', this.handleOrientationChange);
    this.handleResize();
    window.addEventListener("orientationchange", this.handleOrientationChange);
    // 初始加载时检测一次方向
    this.handleOrientationChange();
    this.querInfo();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener("orientationchange", this.handleOrientationChange);
  },
  methods: {
    // 处理屏幕方向变化
    handleOrientationChange() {
      this.isLandscape = false;
      this.isLandscape = window.orientation === 90 || window.orientation === -90;
      console.log(' this.isLandscape', this.isLandscape);
      // this.windowHeight = !this.isLandscape ? window.innerHeight - 295 : window.innerHeight - 295;
      // this.windowHeight = window.innerHeight - 295;
      // this.handleResize();
    },
    // 处理窗口大小变化
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      // this.windowHeight = this.isLandscape ? window.innerHeight - 295 : window.innerHeight - 695;
      this.windowHeight = window.innerHeight - 295;
      // console.log(this.windowHeight, 'this.windowHeight');

    },
    //搜索
    changePolicyStatus() {
      this.querInfo();
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.querInfo1();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.querInfo1();
    },
    //获取商保填报信息列表
    querInfo() {
      this.pageData = {
        page: 1,
        pageSize: 20
      };
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        keywords: this.keywords,
        policyStatus: this.policyStatus,
        ...this.pageData
      };
      this.loading = true;
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          this.tableData = res.data.map(item => {
            item.declareTime = item.declareTime ? moment(item.declareTime).format('YYYY-MM-DD') : null;
            item.birthDate = item.birthDate ? moment(item.birthDate).format('YYYY-MM-DD') : null;
            item.active = item.active == 0 ? '在职' : item.active == 5 ? '离职' : '';
            item.isInsured = item.isInsured == 1 ? '是' : item.isInsured == 0 ? '否' : '';
            item.isMarried = item.isMarried == 1 ? '是' : item.isMarried == 0 ? '否' : '';
            item.isStudent = item.isStudent == 1 ? '是' : item.isStudent == 0 ? '否' : '';
            item.gender = item.gender == 1 ? '男' : item.gender == 2 ? '女' : '';
            return item;
          });
          this.total = res.total;
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    //获取商保填报信息列表
    querInfo1() {
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        keywords: this.keywords,
        policyStatus: this.policyStatus,
        ...this.pageData
      };
      this.loading = true;
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          this.tableData = res.data.map(item => {
            item.declareTime = item.declareTime ? moment(item.declareTime).format('YYYY-MM-DD') : null;
            item.birthDate = item.birthDate ? moment(item.birthDate).format('YYYY-MM-DD') : null;
            item.active = item.active == 0 ? '在职' : item.active == 5 ? '离职' : '';
            item.isInsured = item.isInsured == 1 ? '是' : item.isInsured == 0 ? '否' : '';
            item.isMarried = item.isMarried == 1 ? '是' : item.isMarried == 0 ? '否' : '';
            item.isStudent = item.isStudent == 1 ? '是' : item.isStudent == 0 ? '否' : '';
            item.gender = item.gender == 1 ? '男' : item.gender == 2 ? '女' : '';
            return item;
          });
          console.log(111111111, this.tableData);
          this.total = res.total;
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    //下载模板
    hanleExport() {
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        ...this.pageData
      };
      this.exportBtnLoading = true;
      apis.exportEmployeeChild(json).then(res => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `商保填报模板.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.exportBtnLoading = false;
      }).catch(() => {
        this.exportBtnLoading = false;
      });
    },
    //上传
    afterTwo(file) {
      // this.lookExcelName = file.file.name;
      if (this.fileListTwo.length > 0) {
        this.$message({
          type: "warning",
          message: "只能上传一个excel",
          duration: 1000
        });
      } else {
        const files = [file];
        let params = new FormData();
        params.append("file", files[0].file);
        console.log('params11111', params);
        this.fileListTwo.push({ name: file.file.name });
        // this.flagExcel = true;
        apis.importPolicy({ file: params }).then(data => {

          if (data.code == 200) {
            this.fileListTwo = [];
            this.$message({
              message: "导入成功",
              type: "success"
            });
          }
        }).catch(() => {
          this.fileListTwo = [];
        });
      }
    },
    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);

    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }

  .costContainer1 {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }

  .costContainer1 {
    width: 100%;
  }
}

::v-deep {
  .el-table .cell.el-tooltip {
    width: 100% !important;
  }
}

.costContainer {
  padding-top: 20px;

  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 20px 15px 20px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282B32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    // height: 112px;
    background-color: #fff;
    margin-bottom: 20px;
    padding: 20px;
    // display: flex;
    // justify-content: space-around;
    // align-content: center !important;
    // flex-wrap: wrap-reverse;

    .el-input {
      width: 100%;
      margin-bottom: 20px;
    }

    .el-select {
      width: 50%;
    }
  }

  .costContent {
    height: calc(100vh - 420px);
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }

  .footerBtn {
    background-color: #fff;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: space-around;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45%;
      font-size: 32px;
      border-radius: 8px;
      padding: 20px 0;
      text-align: center;
      // margin-right: 40px;
      border: 1px solid #4ea27c;

      img {
        width: 34px;
        height: 38px;
        margin-right: 10px;
      }
    }

    .exportBtn {
      background-color: #fff;
      color: #4ea27c;
    }

    .importBtn {
      display: flex;
      align-items: center;
      background-color: #4ea27c;
      color: #fff;
    }

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 10px;
      font-size: 27px;
      border: 0;
    }
  }

  .pageContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}

.costContainer1 {
  padding-top: 20px;
  height: 100vh;
  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 10px 15px 10px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282B32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    // height: 112px;
    background-color: #fff;
    // margin-bottom: 10px;
    padding: 20px;
    display: flex;
    justify-content: space-around;
    align-content: center !important;
    flex-wrap: wrap-reverse;

    .el-input {
      width: 40%;
      margin-bottom: 20px;
    }

    .el-select {
      width: 40%;
    }
  }

  .costContent {
    height: calc(100vh - 330px);
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }

  .footerBtn {
    background-color: #fff;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: space-around;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45%;
      font-size: 32px;
      border-radius: 8px;
      padding: 20px 0;
      text-align: center;
      // margin-right: 40px;
      border: 1px solid #4ea27c;

      img {
        width: 34px;
        height: 38px;
        margin-right: 10px;
      }
    }

    .exportBtn {
      background-color: #fff;
      color: #4ea27c;
    }

    .importBtn {
      display: flex;
      align-items: center;
      background-color: #4ea27c;
      color: #fff;
    }

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 10px;
      font-size: 27px;
      border: 0;
    }
  }

  .pageContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
